import "./style.scss"

import React, { useEffect, useRef } from "react"

const EventMap = ({ venue }) => {
  const mapRef = useRef(null)
  const mapInstanceRef = useRef(null)

  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    if (!mapRef.current) {
      return
    }

    const lat = parseFloat(venue?.latitude)
    const lng = parseFloat(venue?.longitude)

    if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
      return
    }

    import("leaflet").then(L => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove()
        mapInstanceRef.current = null
      }

      const map = L.map(mapRef.current).setView([lat, lng], 15)
      mapInstanceRef.current = map

      // OSM's tile policy requires a Referer and has retired the {s} subdomains.
      // Without the explicit policy, browsers that strip the Referer (in-app
      // webviews, privacy modes) get the "Access blocked" 403 tile.
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
        referrerPolicy: "strict-origin-when-cross-origin"
      }).addTo(map)

      const redIcon = L.icon({
        iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
        shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      })

      const marker = L.marker([lat, lng], { icon: redIcon }).addTo(map)

      const addressParts = []
      if (venue?.street) addressParts.push(venue.street)
      if (venue?.street_number) addressParts.push(venue.street_number)
      if (venue?.city) addressParts.push(venue.city)
      if (venue?.postal_code) addressParts.push(venue.postal_code)

      const popupContent = `
        <div class="map-popup">
          <strong>${venue?.name || "Event Location"}</strong>
          ${addressParts.length > 0 ? `<br/>${addressParts.join(", ")}` : ""}
        </div>
      `
      marker.bindPopup(popupContent).openPopup()

      setTimeout(() => {
        map.invalidateSize()
      }, 100)
    })

    // Cleanup on unmount
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove()
        mapInstanceRef.current = null
      }
    }
  }, [venue])

  const lat = parseFloat(venue?.latitude)
  const lng = parseFloat(venue?.longitude)

  // Don't render if no valid coordinates
  if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
    return null
  }

  return (
    <div className="event-map-container">
      <h3 className="event-map-title">Location</h3>
      <div ref={mapRef} className="event-map" />
    </div>
  )
}

export default EventMap
